
export const permissionsList = {
  ADMINISTRAR_ACCESO_USUARIOS: "ADMINISTRAR_ACCESO_USUARIOS",
  ADMINISTRAR_PERIODOS: "ADMINISTRAR_PERIODOS",
  ADMINISTRAR_OBJETIVOS: "ADMINISTRAR_OBJETIVOS",
  ADMINISTRAR_CATEGORIAS: "ADMINISTRAR_CATEGORIAS",
  VER_CUADRO_DE_MANDO: "VER_CUADRO_DE_MANDO",
  FILTRO_CUADRO_DE_MANDO: "FILTRO_CUADRO_DE_MANDO",
  EDITAR_CUADRO_DE_MANDO: "EDITAR_CUADRO_DE_MANDO",
  CREAR_CUADRO_DE_MANDO: "CREAR_CUADRO_DE_MANDO",
  ELIMINAR_CUADRO_DE_MANDO: "ELIMINAR_CUADRO_DE_MANDO",
  ASIGNAR_USUARIOS_CUADRO_DE_MANDO: "ASIGNAR_USUARIOS_CUADRO_DE_MANDO",
  CAPTURAR_INDICADORES: "CAPTURAR_INDICADORES",
  CREAR_O_EDITAR_INDICADORES: "CREAR_O_EDITAR_INDICADORES",
  CREAR_O_EDITAR_SERIES: "CREAR_O_EDITAR_SERIES",
  DUPLICAR_INDICADORES: "DUPLICAR_INDICADORES",
  CARGA_DE_ARCHIVO_PDF: "CARGA_DE_ARCHIVO_PDF",
  EDITAR_MISION_VISION: "EDITAR_MISION_VISION_CONALEP",
  CAPTURA_METAS_CUADRO_MANDO: "CAPTURA_META_CUADRO_MANDO",
  CAPTURA_VARIABLES_INDICADORES_CUADRO_MANDO: "CAPTURA_VARIABLES_INDICADORES_CUADRO_MANDO",
  ACCESO_A_CONTRIBUIDORES_CUADRO_MANDO: "ACCESO_A_CONTRIBUIDORES_CUADRO_MANDO",
  ACCESO_AL_COMPONENTE_FILTRO_DE_INDICADORES: "ACCESO_AL_COMPONENTE_FILTRO_DE_INDICADORES",
  ELIMINAR_INDICADORES_CUADRO_MANDO: "CMI_ELIMINAR_INDICADORES",
  ELIMINAR_SERIES_CUADRO_MANDO: "CMI_ELIMINAR_SERIES",
  CMI_RESET_REGISTROS: "CMI_RESET_REGISTROS",
}